@switch (activeOption) {
    @case (financialObligationOption.OPTIONS) {
        <financial-obligations-options></financial-obligations-options>
    }
    @case (financialObligationOption.STUDENT_DEBT) {
        <student-debt></student-debt>
    }
    @case (financialObligationOption.PAYMENT_ACCOUNT_OVERDRAFT) {
        <payment-account-overdraft></payment-account-overdraft>
    }
    @case (financialObligationOption.MOBILE_PHONE_PAYMENT) {
        <mobile-phone-payment></mobile-phone-payment>
    }
    @case (financialObligationOption.OPEN_ENDED_CREDIT) {
        <open-ended-credit></open-ended-credit>
    }
    @case (financialObligationOption.CREDIT_CARD) {
        <credit-card></credit-card>
    }
    @case (financialObligationOption.PRIVATE_LEASE) {
        <private-lease></private-lease>
    }
    @case (financialObligationOption.PERSONAL_LOAN) {
        <personal-loan></personal-loan>
    }
    @case (financialObligationOption.PARTNER_ALIMONY) {
        <partner-alimony></partner-alimony>
    }
    @case (financialObligationOption.SUMMARY) {
        <financial-obligations-summary></financial-obligations-summary>
    }
}
